import { addMonths } from 'date-fns';

import { INVOICE_STATUS } from 'utils/GeneratedApi';

export const DEFAULT_COUNTRY_CALLING_CODE = '+47';
export const USER_PROFILE_TAG = 'userProfile';

export const MEMBER_CONSENTS_TAG = 'memberConsents';
export const MEMBER_LEDGER_TAG = 'memberLedger';
export const MEMBER_INVOICES_TAG = 'memberInvoices';
export const MEMBER_COMMUNICATIONS_TAG = 'memberCommunications';
export const COMMUNICATION_EMAIL_LIST_TAG = 'communicationEmailList';

export const MAX_PRODUCT_QUANTITY_LIMIT = 10;

// We need to hide the optional product, when the quantity is set to 0
export const HIDE_PRODUCT_QUANTITY = 0;

// We need to allow to purchase unlimited optional product, when the quantity is set to -1
export const UNLIMITED_PRODUCT_QUANTITY = -1;

export const PAYMENT_STATUS_COLORS = {
  PAID: 'bg-green-500',
  DUE: 'bg-yellow-500',
};

export const PRODUCT_QUANTITY_RANGE_OPTIONS = [
  { label: 'Hide', value: HIDE_PRODUCT_QUANTITY },
  { label: 'Unlimited', value: UNLIMITED_PRODUCT_QUANTITY },
  ...Array.from({ length: MAX_PRODUCT_QUANTITY_LIMIT }, (_, i) => ({
    label: `${i + 1}`,
    value: `${i + 1}`,
  })),
];

export const ONE_SECOND_IN_MILLISECONDS = 1000; // 1 second in milliseconds

export const GRAPH_COLORS = {
  BLUE: 'rgba(42, 131, 235, 0.7)', // Blå
  GREEN: 'rgba(39, 191, 29, 0.7)', // Grønn
  ORANGE: 'rgba(235, 101, 42, 0.7)', // Oransje
  PURPLE: 'rgba(183, 157, 255, 0.7)', // Lilla
  YELLOW: 'rgba(246, 243, 96, 0.7)', // Gul
  BRIGHT_MAGENTA: 'rgba(232, 76, 154, 0.7)', // Lys magenta
  MUTED_SLATE_GRAY: 'rgba(109, 127, 129, 0.7)', // Muttet sølv
  SOFT_CORAL_PINK: 'rgba(255, 182, 193, 0.7)', // Lys rosa
  DEEP_TEAL: 'rgba(26, 102, 127, 0.7)', // Dyp teal
  GOLDENROD: 'rgba(225, 168, 37, 0.7)', // Gyllenrod
  // LIGHT_GRAY: 'rgba(245, 249, 255, 0.7)', // Lys grå
  // BLACK: 'rgba(27, 28, 27, 0.7)', // Sort
  // WHITE: 'rgba(255, 255, 255, 0.7)', // Hvit
};

export const SECONDS_IN_A_HOUR = 3600;
export const SECONDS_IN_A_DAY = 24 * SECONDS_IN_A_HOUR;

export const SIX_MONTHS = 6;
export const ONE_DAY = 1;

// Calculate max date as 6 months from today
export const maxFutureActivationStartDate = addMonths(new Date(), SIX_MONTHS);
export const minFutureActivationStartDate = new Date();

export const MINIMUM_NEXT_RENEWAL_DATE_EXTENSION_FOR_VIPPS = 3;

export const MINIMUM_NEXT_RENEWAL_DATE_EXTENSION_FOR_NETS_STRIPES = 1;

export const MINIMUM_NEXT_RENEWAL_DATE_EXTENSION_FOR_EXTERNAL = 1;

export const DATE_TYPE_CUSTOM_PROPERTIES = ['mufcExpiration'];

export const DEFAULT_DOWNLOAD_FORMAT = 'xlsx';

export const DOWNLOAD_FORMAT_OPTIONS = [
  { value: 'xlsx', label: 'XLSX' },
  { value: 'csv', label: 'CSV' },
];

export const DUE_INVOICE_STATUSES = [INVOICE_STATUS.Unpaid, INVOICE_STATUS.OverDue];

// Define fields that should not show the Change button if they already have values
// This is to prevent the group owner from changing the email or phone number
export const HIDDEN_CTA_FIELDS = ['email', 'phone'];

export const IMPORT_SUBSCRIPTIONS_FILE_NAME = 'subscription_import_example_template.xlsx';

export const IMPORT_SUBSCRIPTIONS_HEADERS = [
  'email',
  'fullName',
  'phone',
  'companyName',
  'organizationNo',
  'address',
  'city',
  'country',
  'postCode',
  'packageId',
  'paymentProvider',
  'optionalProductId1',
  'quantity1',
  'optionalProductId2',
  'quantity2',
  'optionalProductId3',
  'quantity3',
  'isPaid',
  'nextRenewalDate',
  'autoRenew',
];

export const IMPORT_SUBSCRIPTIONS_DUMMY_DATA = [
  [
    'dummy.one@example.com',
    'Test Person One',
    '+4791234567',
    'Demo Company ABC',
    '987654321',
    'Test Street 123',
    'Oslo',
    'NO',
    '0150',
    '66',
    'free',
    '1',
    '5',
    '',
    '',
    '',
    '',
    'ja',
    '2026-04-15',
    'ja',
  ],
  [
    'dummy.two@example.com',
    'Example User Two',
    '+4745678901',
    'Sample Corp XYZ',
    '974761076',
    'Demo Avenue 456',
    'Bergen',
    'NO',
    '5020',
    '66',
    'invoice',
    '3',
    '2',
    '',
    '',
    '',
    '',
    'ja',
    '2026-04-15',
    'ja',
  ],
  [
    'dummy.three@example.com',
    'Sample Name Three',
    '+4798765432',
    'Test Business 123',
    '911986884',
    'Example Road 789',
    'Trondheim',
    'NO',
    '7010',
    '66',
    'external',
    '4',
    '6',
    '',
    '',
    '',
    '',
    'Nei',
    '',
    'Nei',
  ],
  [
    'dummy.four@example.com',
    'Demo Person Four',
    '+4743210987',
    'Dummy Corp 456',
    '995276640',
    'Test Lane 012',
    'Stavanger',
    'NO',
    '4006',
    '67',
    'external',
    '2',
    '7',
    '',
    '',
    '',
    '',
    'ja',
    '2026-04-17',
    'ja',
  ],
  [
    'dummy.five@example.com',
    'Test User Five',
    '+4791122334',
    'Sample AS 789',
    '889640782',
    'Demo Path 345',
    'Tromsø',
    'NO',
    '9008',
    '67',
    'external',
    '2',
    '4',
    '',
    '',
    '',
    '',
    'ja',
    '2026-04-17',
    'Nei',
  ],
];

export const REVALIDATION_TIME_IN_SECONDS_INFREQUENTLY_CHANGED_DATA = 60; // 1 minute
export const REVALIDATION_TIME_IN_SECONDS_FREQUENTLY_CHANGED_DATA = 0; // 0 seconds

export const MAX_INVOICE_BATCH_DOWNLOAD_LIMIT = 2000;
